import { render, staticRenderFns } from "./DIS_Special.vue?vue&type=template&id=6da6c250&"
import script from "./DIS_Special.vue?vue&type=script&lang=js&"
export * from "./DIS_Special.vue?vue&type=script&lang=js&"
import style0 from "./DIS_Special.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports